import { useNavigate } from 'react-router-dom';
import { Paper, Typography, Box, Link } from '@mui/material';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { fileExplorerAPI } from '../services/api';

const VideoPlayer = ({ video }) => {
    const navigate = useNavigate();

    if (!video) {
        return (
            <Paper
                elevation={2}
                sx={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'grey.100'
                }}
            >
                <Typography variant="h6" color="textSecondary">
                    Select a video to play
                </Typography>
            </Paper>
        );
    }

    const videoUrl = fileExplorerAPI.getVideoUrl(video.path);

    return (
        <Paper elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <Link href="/" color="inherit" underline="none" sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                        variant="contained" // or "outlined", "text"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("/")}
                    >
                        Back
                    </Button>
                </Link>
                <Typography variant="h6" noWrap>
                    {video.name}
                </Typography>
            </Box>
            <Box sx={{ flex: 1, p: 2 }}>
                <video
                    controls
                    autoPlay
                    style={{ width: '100%', height: '100%', maxHeight: '70vh' }}
                    src={videoUrl} type="video/mp4"
                >
                    Your browser does not support the video tag.
                </video>
            </Box>
        </Paper>
    );
};

export default VideoPlayer;